import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useBrandTheme from '@hooks/useBrandTheme'

const BrandTheme = (props) => {
  const {
    brandTheme,
    brandTheme: {
      title,
    },
  } = props

  const brandThemePayload = useBrandTheme(brandTheme)
  const {
    callbacks: {
      createOrEditBrandTheme,
    },
  } = brandThemePayload

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditBrandTheme()}
      title={title}
    />
  )
}

BrandTheme.propTypes = {
  brandTheme: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }),
}

export default BrandTheme
